type FeatureMeta = {
  name: string;
  unit: string;
  display_name: string;
};

export const features: FeatureMeta[] = [
  {
    name: "text_translation",
    unit: "characters",
    display_name: "Text Translation",
  },
  {
    name: "speech_to_text",
    unit: "characters",
    display_name: "Speech to Text",
  },
  { name: "text_to_speech", unit: "minutes", display_name: "Text to Speech" },
  {
    name: "text_to_speech_with_voice_over",
    unit: "minutes",
    display_name: "Text to Speech with Voice Cloning",
  },
  { name: "voice_cloning", unit: "minutes", display_name: "Voice Cloning" },
  {
    name: "speech_translation",
    unit: "minutes",
    display_name: "Speech Translation",
  },
  { name: "video_subtitle", unit: "minutes", display_name: "Video Subtitle" },
  {
    name: "ms_ttt",
    unit: "characters",
    display_name: "Multi Speaker Text to Text",
  },
  {
    name: "ms_tts_w_vc",
    unit: "minutes",
    display_name: "Multi Speaker TTS with Voice Cloning",
  },
  {
    name: "ms_stt",
    unit: "characters",
    display_name: "Multi Speaker Speech to Text",
  },
  {
    name: "ms_sts_w_vc",
    unit: "minutes",
    display_name: "Multi Speaker STS with Voice Cloning",
  },
  {
    name: "video_translation",
    unit: "minutes",
    display_name: "Video Translation",
  },
  {
    name: "video_translation_w_vc",
    unit: "minutes",
    display_name: "Video Translation with Voice Cloning",
  },
  { name: "ms_vt_w_vc", unit: "minutes", display_name: "Podcast" },
  {
    name: "instant_voice_cloning",
    unit: "minutes",
    display_name: "Instant Voice Cloning",
  },
  {
    name: "lms_vt",
    unit: "minutes",
    display_name: "LMS: Video Translation",
  },
  {
    name: "image_to_video",
    unit: "minutes",
    display_name: "Image to Video",
  },
];
